export function ConfirmationMark() {
  return (
    <div className="af-confirm-mark" aria-hidden="true">
      <span className="af-confirm-mark-pulse" />
      <svg className="af-confirm-check" width="96" height="96" viewBox="0 0 96 96" fill="none">
        <circle className="af-confirm-check-background" cx="48" cy="48" r="34" />
        <circle className="af-confirm-check-ring" cx="48" cy="48" r="34" pathLength="1" />
        <path className="af-confirm-check-path" d="M32 49L43 60L64 38" pathLength="1" />
      </svg>
    </div>
  );
}
